<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
</script>

<template>
    <footer class="footer">
        <div class="inner">
            <div class="logo">
                <img src="/src/assets/images/logo_w.svg" alt="KSA 한국반도체아카데미" />
            </div>
            <div>
                -협회 : 경기도 성남시 분당구 판교역로 182, 한국반도체산업협회회관 9~12층<br/>
                -제 1 교육센터 : 경기도 성남시 대왕판교로 712번길 22, 2층 반도체아카데미<br/>
                <small>* 교육과정별로 교육장이 상이하니, 교육 장소는 모집 공고 참고 바랍니다.</small>

                대표전화 : 1566-8733<br/>
                &copy;COPYRIGHT2023 KOREA SEMICONDUCTOR ACADEMY
            </div>
            <ul class="policy">
              <li @click="router.push({name:'personal'})">개인정보처리방침</li>
              <li @click="router.push({name:'emailRejection'})">이메일무단수집거부</li>
            </ul>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
    @import "../assets/scss/theme";

    .footer {
        width: 100%;
        background: #494B5B;
        color: #808189;
        @include font-size_sm;
        padding: 20px 10px;
        text-align: left;
        small {
          display: block;
          margin-bottom: 10px;
        }
        .inner {
            position: relative;
        }
        .logo {
            width: 200px;
            margin-bottom: 10px;
        }
        .policy {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          align-items: center;
          gap: 10px;
          color: #fff;
          cursor: pointer;
          li:last-child {
            position: relative;
            color: #d2d2d2;
            //margin-left: 10px;
            padding-left: 10px;
            &:before {
              content: '';
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              height: 16px;
              width: 1px;
              background: #808189;
            }
          }
        }
    }
</style>